module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.itemId
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Введите запрос",
      "clearable": "",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.filterString),
      callback: function($$v) {
        _vm.filterString = $$v
      },
      expression: "filterString"
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Категория",
      "hint": _vm.getDisplayPathByPath(_vm.path),
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('span', {
          style: (_vm.styleItem(data.item))
        }, [_vm._v(_vm._s(data.item.value))])]
      }
    }]),
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 168 + 52)
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": true,
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.value,
      on: {
        "click": function($event) {
          return _vm.select(item.value)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('b', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(item.description))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(item.value)),
        expression: "check(item.value)"
      }]
    }, [_vm._v("radio_button_checked")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.check(item.value)),
        expression: "!check(item.value)"
      }]
    }, [_vm._v("radio_button_unchecked")])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb4ecc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/DeedSelector.vue
// module id = 1162
// module chunks = 1